import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { MigrateMutation } from "@/admin/entities/migrations";
import type { Migration } from "@/admin/entities/migrations";

interface MigrationActionsProps {
  migration: Migration;
}

export const MigrationActions: React.FC<MigrationActionsProps> = ({
  migration,
}) => {
  const [migrate, { loading: migrating }] = useMutation(MigrateMutation, {
    onError: (error) => {
      console.error("Migration error:", error);
    },
    update: (cache, { data }) => {
      if (data?.migrate) {
        cache.modify({
          id: cache.identify({ __typename: "Migration", id: migration.id }),
          fields: {
            status: () => "pending",
            error: () => null,
          },
        });
      }
    },
  });

  const handleMigrate = () => {
    if (!migration?.id) return;

    migrate({
      variables: {
        id: migration.id,
      },
    });
  };

  const isProcessing = migration.status === "processing";
  const isDisabled = migrating || isProcessing;

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h6" component="h3">
              Действия
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Управление выполнением миграции
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleMigrate}
              disabled={isDisabled}
              startIcon={migrating && <CircularProgress size={20} />}
            >
              {migrating
                ? "Запуск..."
                : isProcessing
                  ? "Выполняется..."
                  : "Запустить миграцию"}
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
